import React from "react";
import axios from "axios";
import Api from "../../../assets/js/utils/Api";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "../CustomButtons/Button";
import ArrowBack from "@material-ui/icons/ArrowBackIos";
import officeFileModalStyle from "../../../assets/jss/user/officeFileModalStyle";
import LoaderComponent from "../../components/Loader";
import Close from "@material-ui/icons/Close";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "../CustomInput/CustomInput.jsx";
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.mjs`;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" timeout={500} ref={ref} {...props} />;
});
Transition.displayName = "Transition";

const PdfViewModal = class extends React.Component {
    constructor(props) {
        super(props);
        this.store = this.props.store;
        
        this.state = {
            file: this.props.file,
            pdfDoc: null,
            currentPage: 1,
            visitId: null,
            trackPdf: this.props.trackPdf,
            ownerId: this.props.ownerId,
            emailModal: true,
            emailError: false,
        };

        this.containerRef = React.createRef();
        this.startTime = Date.now();
    }

    componentDidMount() {
        const { authorized } = this.store.getState();
        if(!authorized){
            return;
        }

        this.loadPDF();
        window.addEventListener('beforeunload', this.handleUnload);
    }

    componentWillUnmount() {
        const { authorized } = this.store.getState();
        if(!authorized && this.state.emailModal){
            return;
        }

        window.removeEventListener('beforeunload', this.handleUnload);
        this.handleUnload(); 
    }

    handleUnload = () => {
        const timeSpent = Date.now() - this.startTime;
        this.sendTracking(this.state.currentPage, timeSpent);
    };

    sendTracking = async (page, time) => {
        const { user } = this.store.getState();
        const { file, trackPdf, visitId, ownerId, email } = this.state;

        if(!trackPdf){
            return;
        }

        let requestData = {
            owner_id: ownerId,
            user_id: user.id,
            file_id: file.id,
            page: page,
            time_spent: time,
            event: 'page_change',
            visit_id: visitId,
            email: email
        };
        const source = axios.CancelToken.source();

        Api.trackPdf(requestData, source).then(data => {
            this.setState({
                visitId: data.visit_id
            })
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message") && err.message !== 'Request Cancelled'){
                this.setState({
                    saving: false,
                    showError: true,
                    errorMessage: err.message
                });
            }
        });
    };

    loadPDF = async () => {
        const { file } = this.state;
        const doc = await pdfjsLib.getDocument(file.downloadLink).promise;
        this.setState({ pdfDoc: doc }, () => {
            this.sendTracking(1, 0);
            this.renderPage(1);
        });
    };

    renderPage = async (num) => {
        const { pdfDoc, currentPage } = this.state;
        if (!pdfDoc || num < 1 || num > pdfDoc.numPages) return;

        const page = await pdfDoc.getPage(num);
        const viewport = page.getViewport({ scale: 1.5 });

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        await page.render({ canvasContext: context, viewport }).promise;

        if (this.containerRef.current) {
            this.containerRef.current.innerHTML = '';
            this.containerRef.current.appendChild(canvas);
        }

        const timeSpent = Date.now() - this.startTime;
        if (num !== currentPage) {
            this.sendTracking(currentPage, timeSpent);
            this.startTime = Date.now();
        }

        this.setState({ currentPage: num });
    };

    handlePrevious = () => {
        const { currentPage } = this.state;
        this.renderPage(currentPage - 1);
    };

    handleNext = () => {
        const { currentPage } = this.state;
        this.renderPage(currentPage + 1);
    };
    onClose(){
        this.props.onClose();
    }
    onPdfPreview(){
        let emailRegex = /\S+@\S+\.\S+/;
        if(!emailRegex.test(this.state.email)){
            this.setState({emailError: true});
            return;
        }

        this.setState({
            emailModal: false,
            emailError: false
        }, () => {
            this.loadPDF();
            window.addEventListener('beforeunload', this.handleUnload);
        });
    }
    handleChange(e, name){
        let state = {};
        state[name] = e.target.value;
        this.setState(state);
    }
    render() {
        const { classes } = this.props;
        const { file, pdfDoc, currentPage, emailModal, email } = this.state;
        const { authorized } = this.store.getState();
        const numPages = pdfDoc ? pdfDoc.numPages : 0;

        if(!authorized && emailModal){
            return (
                <Dialog
                    classes={{
                        root: classes.modalRoot,
                        paper: classes.modalCustom
                    }}
                    open={this.props.open}
                    TransitionComponent={Transition}
                    keepMounted
                    aria-labelledby="deleteFile-slide-title"
                    aria-describedby="deleteFile-slide-description"
                >
                    <DialogTitle
                        id="attachments-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                    >
                        <Button
                            simple
                            className={classes.modalCloseButton+" "+classes.modalCloseButtonCustom}
                            key="close"
                            aria-label="Close"
                            onClick={() => this.props.onClose()}
                        >
                            {" "}
                            <Close className={classes.modalClose} />
                        </Button>
                        <h4 className={classes.modalTitle}>Please enter email for view pdf</h4> 
                    </DialogTitle>
                    <DialogContent
                        id="deleteFile-slide-description"
                        className={classes.modalBody}
                    >
                        <CustomInput
                            error={this.state.emailError}
                            id="input-emailText"
                            labelText="Email"
                            inputProps={{
                                onChange: (e) => this.handleChange(e,'email'),
                                value: email,
                                name: "email",
                                type: "text",
                            }}
                            color="custom"
                            formControlProps={{
                                fullWidth: true,
                                className: 'custom-input'
                            }}
                        />
                    </DialogContent>
                    <DialogActions
                        className={classes.modalFooter}
                    >
                        <Button color="custom" onClick={() => this.onPdfPreview()}>Preview</Button>
                    </DialogActions>        
                </Dialog>
            );
        }
        return (
            <Dialog
                classes={{
                    root: classes.modalRoot+" overflow-auto",
                    paper: classes.modal
                }}
                open={this.props.open}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="officeFileModal-slide-title"
                aria-describedby="officeFileModal-slide-description"
                onClose={() => this.onClose()}
            >
                <DialogContent
                    id="officeFileModal-slide-description"
                    className={classes.modalBody}
                    ref={this.modelBodyRef}
                >
                    <div className={classes.mainContainer+" "+classes.expandedMainContainer}>
                        <div className={classes.middleContainer}>
                            <div className={classes.topContainer}>
                                <Button color="custom" onClick={() => this.onClose()} className={classes.backButton} justIcon>
                                    <ArrowBack />
                                </Button>
                                <div className={classes.basicFileDetails}>
                                    {file.name}
                                </div>
                            </div>
                            <div className={classes.officeIframeContainer} id="frameholder">
                                {
                                    pdfDoc === null ?
                                        <div className="loader">
                                            <LoaderComponent color="custom" align="center" />
                                        </div>
                                    :
                                        <div ref={this.containerRef}></div>
                                }
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className={classes.modalFooter}>
                    {pdfDoc && currentPage > 1 && (
                        <Button color="custom" onClick={() => this.handlePrevious()}>Previous</Button>
                    )}
                    {pdfDoc && currentPage < numPages && (
                        <Button color="custom" onClick={() => this.handleNext()}>Next</Button>
                    )}
                </DialogActions>
            </Dialog>
        );
    }
}

PdfViewModal.defaultProps = {
    open: false,
    trackPdf: false
};
PdfViewModal.propTypes = {
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
    open: PropTypes.bool,
    file: PropTypes.object,
    trackPdf: PropTypes.bool,
    ownerId: PropTypes.string || PropTypes.number
};
export default withStyles(officeFileModalStyle)(PdfViewModal);